import Api from '../Api';

import { url } from './config';
import { Airport } from './types';

const api = new Api<Airport>(url);

export default api;
